export default __webpack_public_path__ + "static/media/menu.1734bc41.svg";